import makeRequest from "rdx/utils/makeRequest";
import { all, put } from "redux-saga/effects";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import messages from "../messages";

function* createTeamAssignment(action) {
  const { teamId, userId, teamRole, parentId } = action.payload;
  const { success, data, error } = yield* makeRequest.post(`/sales_teams/${teamId}/assign`, {
    user_id: userId,
    team_role: teamRole,
    parent_id: parentId,
  });

  if (success && data) {
    yield all([
      put(actions.getTeams()),
      put(actions.getSellers()),
      put(actions.getAvailableSupport()),
      put(actions.setAlertMessageVisible({ message: messages.SUCCESS_CREATING_TEAM_ASSIGNMENT, severity: "success" })),
    ]);
  } else {
    return getErrorActions({
      error,
      message: messages.ERROR_CREATING_TEAM_ASSIGNMENT,
    });
  }

  return null;
}

export default createTeamAssignment;
